module.exports = "/static/assets/f0162f213bfedc30557803936e40d928.png";